const PriceMovementDuration = {
  last4Weeks: "last4Weeks",
  last6Months: "last6Months",
  last12Months: "last12Months",
  dateRange: "dateRange",
};

export default PriceMovementDuration;
